import useCommandChannel from '../hooks/useCommandChannel'

const CommandChannelHandler = () => {
    useCommandChannel()
    return null
}

export default CommandChannelHandler 